module.exports = __webpack_public_path__ + "img/logo-2.e64b5dac.png";